<script lang="ts">
import { useIntersectionObserver } from "@vueuse/core";
import { ref, useTemplateRef } from "vue";
export default {
  props: {
    root: { type: String, required: true },
  },
  setup(props) {
    const shouldRender = ref(false);
    const root = useTemplateRef<HTMLDivElement>(props.root);
    const targetEl = ref();
    const { isActive } = useIntersectionObserver(
      targetEl,
      ([{ isIntersecting }]) => {
        shouldRender.value = isIntersecting;
      },
      {
        root,
        rootMargin: "1000px",
        threshold: 0,
      },
    );

    return { targetEl, shouldRender, isActive };
  },
};
</script>
<template>
  <div ref="targetEl" class="multiselect-lazy-checkbox-placeholder">
    <slot v-if="shouldRender" />
  </div>
</template>
<style>
.multiselect-lazy-checkbox-placeholder {
  min-height: 1.3125rem;
}
</style>
